import {generalRequest} from "@/lib/services/requests";
import {useMutation, useQuery} from "@tanstack/react-query";

export const useApiSearchAdminProducts = (args) => {
    return useQuery({
        queryKey: ['admin', 'product', 'search', args],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/admin/products`, {params: config});
        })(args)),
    })
}


export const useApiGetAdminProduct = (args) => {
    return useQuery({
        queryKey: ['admin', 'product', 'get', args],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/admin/products/${config.id}`)
        })(args)),
    })
}


export const useApiSearchAdminProductsDeliveryStep = (args) => {
    return useQuery({
        queryKey: ['admin', 'product-delivery-step', 'search', args],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/admin/products/deliveries/step`, {params: config});
        })(args)),
    })
}


export const useApiSearchAdminProductsDeliveryStepCategoryStatistic = (args) => {
    return useQuery({
        queryKey: ['admin', 'product-delivery-step', 'category-statistic', args],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/admin/products/deliveries/category-statistic`, {params: config});
        })(args)),
    })
}


export const useApiSearchAdminProductsDelivery = (args) => {
    return useQuery({
        queryKey: ['admin', 'product-delivery', 'search', args],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/admin/products/deliveries`, {params: config});
        })(args)),
    })
}

export const useApiSearchAdminProductsDeliveryStepLesson = (args) => {
    return useQuery({
        enabled: !!args?.id,
        queryKey: ['admin', 'product-delivery', 'search-step-lesson', args],
        queryFn: () => ((async (args = {}) => {
            return generalRequest.get(`/admin/products/deliveries/step/${args?.id}/lessons`, {params: args});
        })(args)),
    })
}
export const useApiGetAdminProductsDeliveryStep = (args) => {
    return useQuery({
        queryKey: ['admin', 'product-delivery', 'get', args],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/admin/products/deliveries/step/${config?.id}`, {params: config});
        })(args)),
    })
}


export function useApiPutAdminProductDeliveryStep() {
    return useMutation({
        mutationFn: (data) =>
            ((async (config = {}) => {
                return generalRequest.put(`/admin/products/deliveries/step/${config?.id}`, config);
            })(data))
    });
}


export function useApiDeleteAdminProductDelivery() {
    return useMutation({
        mutationFn: (data) =>
            ((async (config = {}) => {
                return generalRequest.delete(`/admin/products/deliveries/${config?.id}`);
            })(data))
    });
}

export function useApiUpdateAdminProductDelivery() {
    return useMutation({
        mutationFn: (data) =>
            ((async (config = {}) => {
                return generalRequest.put(`/admin/products/deliveries/${config?.id}`, config);
            })(data))
    });
}

export function useApiPutAdminProductDeliveryStepNotif() {
    return useMutation({
        mutationFn: (data) =>
            ((async (config = {}) => {
                return generalRequest.put(`/admin/products/deliveries/step/${config?.id}/notif`, config);
            })(data))
    });
}


export function useApiPostAdminProductDeliveryStepManual() {
    return useMutation({
        mutationFn: (data) =>
            ((async (config = {}) => {
                return generalRequest.post(`/admin/products/deliveries/step/manual`, config);
            })(data))
    });
}


export const useApiSearchAdminProductsDeliveryOnly = (args) => {
    return useQuery({
        enabled: !!args?.search,
        queryKey: ['admin', 'product-delivery', 'search-only', args],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/admin/products/deliveries/search`, {params: config});
        })(args)),
    })
}

export const useApiSearchAdminProductsDeliveryToLesson = (args) => {
    return useQuery({
        enabled: !!args?.search || !!args?.code,
        queryKey: ['admin', 'product-delivery', 'search-to-lesson', args],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/admin/products/deliveries/action/deliver/lesson`, {params: config});
        })(args)),
    })
}


export function useApiCreateAdminProductDeliveryActionDeliver() {
    return useMutation({
        mutationFn: (data) =>
            ((async (config = {}) => {
                return generalRequest.post(`/admin/products/deliveries/action/deliver`, config)
            })(data))
    });
}

export function useApiCreateAdminProductDeliveryActionDeliverToLesson() {
    return useMutation({
        mutationFn: (data) =>
            ((async (config = {}) => {
                return generalRequest.post(`/admin/products/deliveries/action/deliver/lesson`, config)
            })(data))
    });
}

export function useApiCreateAdminProductDeliveryActionReceipt() {
    return useMutation({
        mutationFn: (data) =>
            ((async (config = {}) => {
                return generalRequest.post(`/admin/products/deliveries/action/receipt`, config)
            })(data))
    });
}

export function useApiCreateAdminProductDeliveryStep() {
    return useMutation({
        mutationFn: (data) =>
            ((async (config = {}) => {
                return generalRequest.post(`/admin/products/deliveries/step`, config)
            })(data))
    });
}

export function useApiCalculateAdminProductDeliveryStep() {
    return useMutation({
        mutationFn: (data) =>
            ((async (config = {}) => {
                return generalRequest.post(`/admin/products/deliveries/step/calculate`, config)
            })(data))
    });
}


export function useApiCreateAdminProduct() {
    return useMutation({
        mutationFn: (data) =>
            ((async (config = {}) => {
                return generalRequest.post(`/admin/products`, config)
            })(data))
    });
}


export function useApiUpdateAdminProduct() {
    return useMutation({
        mutationFn: (data) =>
            ((async (config = {}) => {
                return generalRequest.put(`/admin/products/${config.id}`, config)
            })(data))
    });
}


export function useApiDeleteAdminProduct() {
    return useMutation({
        mutationFn: (data) =>
            ((async (config = {}) => {
                return generalRequest.delete(`/admin/products/${config.id}`)
            })(data))
    });
}
